import { render, staticRenderFns } from "./GiftCompanyModal.vue?vue&type=template&id=3c50a8aa&"
import script from "./GiftCompanyModal.vue?vue&type=script&lang=js&"
export * from "./GiftCompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c50a8aa')) {
      api.createRecord('3c50a8aa', component.options)
    } else {
      api.reload('3c50a8aa', component.options)
    }
    module.hot.accept("./GiftCompanyModal.vue?vue&type=template&id=3c50a8aa&", function () {
      api.rerender('3c50a8aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/auth/modules/GiftCompanyModal.vue"
export default component.exports